var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 18 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  d: "M16.5 9c0-4.567-3.129-7.5-7.5-7.5S1.5 4.433 1.5 9c0 3.145 2.487 7.55 7.5 13.134 5.014-5.583 7.5-9.99 7.5-13.134M0 9c0-5.418 3.821-9 9-9s9 3.582 9 9c0 3.679-2.736 8.466-8.167 14.45a1.125 1.125 0 0 1-1.589.077c-.04-.038-.04-.038-.077-.077C2.737 17.466 0 12.679 0 9m9 3a3.75 3.75 0 1 1 0-7.5A3.75 3.75 0 0 1 9 12m0-1.5A2.25 2.25 0 1 0 9 6a2.25 2.25 0 0 0 0 4.5"
})));
export default SvgVector;